module.exports = __webpack_public_path__ + "img/sensitive-events-widget.c0ba95f4.png";